import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import Lightbox from "./lightbox"

const Image = ({
  fileName,
  className,
  style,
  lightbox = false,
  lightboxLinkUrl,
  lightboxLinkLabel,
  alt = "",
  fluid = false,
}) => {
  // All Images
  const data = useStaticQuery(graphql`
    query {
      images: allFile(filter: { extension: { ne: "md" } }) {
        edges {
          node {
            childImageSharp {
              fluid(maxWidth: 900, quality: 90) {
                ...GatsbyImageSharpFluid
              }
              fixed(width: 200) {
                ...GatsbyImageSharpFixed
              }
            }
            relativePath
            publicURL
            name
            dir
            ext
            extension
            absolutePath
            id
          }
        }
      }
    }
  `)

  const image = data.images.edges.find(
    edge => edge.node.relativePath === fileName
  )

  if (image) {
    const renderedImage = (
      <Img
        alt={alt}
        fixed={fluid ? undefined : image.node.childImageSharp.fixed}
        fluid={fluid ? image.node.childImageSharp.fluid : undefined}
        className={className}
        style={style}
      />
    )

    if (lightbox) {
      return (
        <Lightbox
          imageAlt={alt}
          imageUrl={image.node.publicURL}
          linkUrl={lightboxLinkUrl}
          linkLabel={lightboxLinkLabel}
        >
          {renderedImage}
        </Lightbox>
      )
    }

    return renderedImage
  }
  return <></>
}

export default Image
